import { cn } from '@/shared/lib/utils';
import { Fragment, type ReactNode } from 'react';
import { Icon } from './Icon';

interface DotSeparatedProps {
  /** null·false 항목은 건너뛴다 */
  items: ReactNode[];
  className?: string;
}

/** "31234567 • 경기 수원시 영통구" 처럼 4px 점으로 구분한 한 줄 */
export function DotSeparated({ items, className }: DotSeparatedProps) {
  const visible = items.filter(
    (item) =>
      item !== null && item !== undefined && item !== false && item !== '',
  );
  return (
    <div className={cn('flex min-w-0 items-center gap-2', className)}>
      {visible.map((item, index) => (
        <Fragment key={index}>
          {index > 0 && <Icon name="dot" size={4} />}
          <span className="min-w-0">{item}</span>
        </Fragment>
      ))}
    </div>
  );
}
